module.exports = __webpack_public_path__ + "static/media/footer-web.661231ce.png";